export type DocumentClassificationMetadata = {
  content_readable?: boolean;
  unreadable_reason?: string | null;
  classification_source?: string;
};

export type DocumentClassificationUiState = {
  classification: string | null;
  classification_error?: string | null;
  metadata?: DocumentClassificationMetadata | null;
};

export function isDocumentContentUnreadable(doc: DocumentClassificationUiState): boolean {
  return doc.metadata?.content_readable === false;
}

export function documentClassificationLabel(doc: DocumentClassificationUiState): string {
  if (doc.classification_error) {
    return "Classification failed";
  }
  if (doc.classification) {
    return doc.classification;
  }
  return "Classifying...";
}

export function isDocumentClassifying(doc: DocumentClassificationUiState): boolean {
  if (doc.classification_error) {
    return false;
  }
  const label = documentClassificationLabel(doc);
  return label === "Classifying..." || label === "Pending...";
}

export function isDocumentClassificationFailed(doc: DocumentClassificationUiState): boolean {
  return Boolean(doc.classification_error);
}

export type ClassificationFailedDocument = {
  id?: string;
  name: string;
  classificationError: string;
};

export function collectClassificationFailures(
  documents: Array<{ id?: string; name: string; classificationError?: string | null }>,
): ClassificationFailedDocument[] {
  return documents
    .filter((doc) => Boolean(doc.classificationError))
    .map((doc) => ({
      ...(doc.id ? { id: doc.id } : {}),
      name: doc.name,
      classificationError: doc.classificationError as string,
    }));
}
